import FORMATS from './modules/formats';
import RESTRICTIONS from './modules/restrictions';
import VISIT from './modules/visit';

export default Object.freeze({
    FORMATS,
    RESTRICTIONS,
    VISIT,
});
